//dependencias
import React, { Component } from 'react';

//componentes
import DonanteAction from './donantes'

class Index extends Component {

    render(){
        return(
            <div>
                <DonanteAction />
            </div>
        );
    }

}
export default Index;